import * as React from "react";
import { BasePrePacksRoot, } from "../../businessLayer";
import { PrePacksWeb } from "./ui";
export class PrePacksWebRoot extends BasePrePacksRoot {
    constructor(domId, options) {
        super(domId, options);
    }
    getComponent() {
        return React.createElement(PrePacksWeb, Object.assign({}, this.props));
    }
}
window["PrePacksWeb"] = PrePacksWebRoot;
//# sourceMappingURL=index.js.map